const nameSubString = (name: string, length: number) => {
    return name && name.length > length
        ? name.substring(0, length - 4) + "..." + name.substring(name.length - 4)
        : name;
};
export { nameSubString };
